import { render, staticRenderFns } from "./ConnectSocialAccounts.vue?vue&type=template&id=23d35340&scoped=true"
import script from "./ConnectSocialAccounts.vue?vue&type=script&lang=js"
export * from "./ConnectSocialAccounts.vue?vue&type=script&lang=js"
import style0 from "./ConnectSocialAccounts.vue?vue&type=style&index=0&id=23d35340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d35340",
  null
  
)

export default component.exports